import React, { useState, useRef, useEffect } from 'react';
import { Box, Grid, Typography, IconButton, Button, Paper } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import { Link, useHistory } from 'react-router-dom';
import { useDeadline } from '../../../../contexts/DeadlineContext';
import { Card, CardActions, CardContent } from '@mui/material';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import { useMediaQuery } from '@mui/material';
// Reusable Paper wrapper for MUI
const Item = ({ children }) => (
  <Paper sx={{ padding: 2, textAlign: 'center' }}>
    {children}
  </Paper>
);

const pending = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);

const AffiliationDashbord = () => {
  const svgRef = useRef(null);
  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';
  const history = useHistory();
  const [permissions, setrPermissions] = useState([]);
  const eventid = localStorage.getItem('eventid');
  const eventName = localStorage.getItem('eventname');
  const [copied, setCopied] = useState(false);
  const backGroundButtonByEvent = '#4caf50';
  const discountLink = `${window.location.origin}/#/conference/event-discount/${eventid}`;
  const [totalReceiptCollection, setTotalAffiationReceiptCollection] = React.useState([]);
  const [totalAffiationBankCollection, setTotalAffiationBankCollection] = React.useState([]);
  const [totalAffiationCashCollection, setTotalAffiationCashCollection] = React.useState([]);
  const [totalAffiationOnlineCollection, setTotalAffiationOnlineCollection] = React.useState([]);

  // const [paindingAffiationCollection, setPaindingAffiationCollection] = React.useState([]);
  const [totalConferencepantCount, setTotalConferencepantCount] = React.useState([]);
  const [totalAffiationParticipantCount, setTotalAffiationParticipantCount] = React.useState([]);
  const [totalAffiationMaleParticipantCount, setTotalAffiationMaleParticipantCount] = React.useState([]);
  const [totalAffiationFemaleParticipantCount, setTotalAffiationFemaleParticipantCount] = React.useState([]);

  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const handleCopy = () => {
    navigator.clipboard.writeText(discountLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  React.useEffect(() => {
    axios.get(`api/getpermissionByRole`).then(res => {

      if (res.status === 200) {
        const datad = res.data.data.permissions;
        setrPermissions(datad)
      } else {

      }
    })

  }, []);
  useEffect(() => {
    axios.get(`api/get-conference-collection?id=${eventid}`).then(res => {
      if (res.status === 200) {

        const affiliate = res.data.affiliate || {};

        setTotalAffiationReceiptCollection(affiliate.receipt || 0);  // <-- use "receipt" not "totalReceipt"
        setTotalAffiationBankCollection(affiliate.bank || 0);        // <-- "bank"
        setTotalAffiationCashCollection(affiliate.cash || 0);        // <-- "cash"
        setTotalAffiationOnlineCollection(affiliate.online || 0);    // <-- "online"

      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    })
  }, []);
  useEffect(() => {
    axios.get(`api/get-conference-participnat-count?id=${eventid}`).then(res => {
      if (res.status === 200) {

        const totalConferenceParticipants = res.data.totalParticipants;
        const totalParticipants = res.data.totalAffiliatedParticipants;
        const maleParticipants = res.data.maleAffiliatedParticipants;
        const femaleParticipants = res.data.femaleAffiliatedParticipants;

        // Keeping the existing state names
        setTotalConferencepantCount(totalConferenceParticipants);
        setTotalAffiationParticipantCount(totalParticipants);
        setTotalAffiationMaleParticipantCount(maleParticipants);
        setTotalAffiationFemaleParticipantCount(femaleParticipants);

      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    });
  }, [eventid]);
  // Download QRCode as image
  const downloadQRCode = (elementId, filename) => {
    const qrCodeURL = document.getElementById(elementId).toDataURL("image/png").replace("image/png", "image/octet-stream");
    const aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = filename;
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  // Download Barcode as image



  const downloadBarcode = (filename) => {
    if (svgRef.current) {
      // Get the SVG content from the ref
      const svg = svgRef.current.outerHTML;

      // Create a Blob for SVG content
      const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });

      // Create a link to download the Blob as an SVG file
      const url = URL.createObjectURL(blob);

      const aEl = document.createElement('a');
      aEl.href = url;
      aEl.download = filename;

      // Trigger the download
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);

      // Clean up the object URL after the download
      URL.revokeObjectURL(url);
    } else {
      console.error('SVG reference not found.');
    }
  };

  //style={{ background: abstractHomeSetup.color_code_one || gradientBackground }}
  return (
    <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
      <Grid container spacing={isSmallScreen ? 2 : 4}>

        <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
          <Button sx={{
            float: 'right',
            marginTop: '0%',
            background: abstractHomeSetup.color_code_two || gradientBackground,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'

            onClick={() => history.goBack()} >
            Back
          </Button>
          <Item>
            <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
              Welcome to the Affiliation Dashboard
            </Typography>

          </Item>
        </Grid>


        <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: "1%" }}>
          {
            isSmallScreen ? (<>
             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
              {
                permissions['p_conference-affiliation-badge'] === true ?
                  <Button
                    sx={{ ":hover": { color: "white" } }}
                    color='success'
                    size='small'
                    variant='contained'
                    to={`/admin/affiliation/badge`}
                    component={Link}
                    style={{ background: abstractHomeSetup.color_code_two || gradientBackground, }}
                  >
                    Affiliation Badge
                  </Button>
                  : ""
              }
            
              {permissions['p_conference-affiliation-reg-report'] === true ?
                <Button
                  sx={{ ":hover": { color: "white" } }}
                  color='success'
                  size='small'
                  variant='contained'
                  to={`/admin/affiliation/participant-report`}
                  component={Link}
                  style={{ background: abstractHomeSetup.color_code_two || gradientBackground, }}
                >
                  Affiliation Registration Report
                </Button>
                : ""}

              {permissions['p_conference-affiliation-reg-attendance'] === true ?
                <Button
                  sx={{ ":hover": { color: "white" } }}
                  color='success'
                  size='small'
                  variant='contained'
                  to={`/admin/affiliation/attendance-report`}
                  component={Link}
                  style={{ background: abstractHomeSetup.color_code_two || gradientBackground,}}
                >
                  Affiliation Attendance Report
                </Button> : ""}
                </Box>
            </>) : (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1 }}>
                  {
                    permissions['p_conference-affiliation-badge'] === true ?
                      <Button
                        sx={{ ":hover": { color: "white" } }}
                        color='success'
                        size='small'
                        variant='contained'
                        to={`/admin/affiliation/badge`}
                        component={Link}
                        style={{ background: abstractHomeSetup.color_code_two || gradientBackground, }}
                      >
                        Affiliation Badge
                      </Button>
                      : ""
                  }

                  {permissions['p_conference-affiliation-reg-report'] === true ?
                    <Button
                      sx={{ ":hover": { color: "white" } }}
                      color='success'
                      size='small'
                      variant='contained'
                      to={`/admin/affiliation/participant-report`}
                      component={Link}
                      style={{ background: abstractHomeSetup.color_code_two || gradientBackground, }}
                    >
                      Affiliation Registration Report
                    </Button>
                    : ""}
                  {permissions['p_conference-affiliation-reg-attendance'] === true ?
                    <Button
                      sx={{ ":hover": { color: "white" } }}
                      color='success'
                      size='small'
                      variant='contained'
                      to={`/admin/affiliation/attendance-report`}
                      component={Link}
                      style={{ background: abstractHomeSetup.color_code_two || gradientBackground, }}
                    >
                      Affiliation Attendance Report
                    </Button> : ""}
                </Box>
              </>

            )
          }


          <Item>
            {eventid && (
              <Typography variant="body1">
                Link to event discount page:{' '}
                <strong>{discountLink}</strong>{' '}
                <IconButton onClick={handleCopy} title="Copy link">
                  <CopyAllIcon />
                </IconButton>
                {copied && (
                  <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                    Copied!
                  </Typography>
                )}
              </Typography>

            )}
          </Item>
        </Grid>


        {/* QR Code Section */}
        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Discount Affiliation Registration QRCode
                    </Typography>
                    <QRCode
                      id="affilifitonConferenceqrCodeEl"
                      size={isSmallScreen ? 100 : 150}
                      value={discountLink}
                      style={{ marginTop: '12px' }} // adds space between title and QRCode
                    />
                  </CardContent>
                  <CardActions>
                    <Button
                      sx={{
                        marginTop: '2%',
                        ":hover": { color: "white" },
                        fontSize: isSmallScreen ? '12px' : '14px',
                        background: abstractHomeSetup.color_code_two || gradientBackground,
                      }}
                      color="success"
                      size="small"
                      variant="contained"  
                      onClick={() => downloadQRCode('affilifitonConferenceqrCodeEl', `${eventName}_Affiliation-QrCode.png`)}
                    >
                      Download
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h6">Discount Affiliation Registration QRCode</Typography>
                    <Barcode ref={svgRef} format="CODE128" width={1} value={discountLink} />
                  </CardContent>
                  <CardActions>
                    <Button
                      sx={{
                        marginTop: '5%', ":hover": { color: "white" },
                        background: abstractHomeSetup.color_code_two || gradientBackground,
                      }}
                      color='success'
                      size='small'
                      variant='contained'
                      onClick={() => downloadBarcode('Affiliation_barcode.svg')}
                    >
                      Download Barcode
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        {/* paticpant Section */}

        {permissions['p_conference-affiliation-participant-count'] === true ?
          <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
            <Item>
              <Typography variant="h6" gutterBottom>
                Total Affiliation Participant Count
              </Typography>
              <Typography variant="body1" paragraph>
                Total Conference Participant Count
                <br />
                <span style={{ color: "red" }}>
                  <strong>Note:</strong> {totalConferencepantCount}
                </span>

              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="success.main" key={1}>
                        {pending}. {totalAffiationParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Male Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="secondary" key={1}>
                        {pending}. {totalAffiationMaleParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Female Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="error.main" key={1}>
                        {pending}. {totalAffiationFemaleParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Item>
          </Grid> : ""}


        {/* Collection Section */}
        {permissions['p_conference-affiliation-collection'] === true ?
          <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
            <Item>
              <Typography variant="h6" gutterBottom>
                Total Affiliation Collection
              </Typography>

              {/* Add a Grid container */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Bank Collection
                      </Typography>
                      <Typography variant="body2" variant="h2" color="success.main" key={1}>
                        {pending}. {totalAffiationBankCollection}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Online Collection
                      </Typography>
                      <Typography variant="body2" variant="h2" color="success.main" key={1}>
                        {pending}. {totalAffiationOnlineCollection}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Item>
          </Grid> : ""}


      </Grid>
    </Box>
  );
};

export default AffiliationDashbord;
